import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const BootstrapModal = ({ show, handleClose, title, children, onConfirm, loading, modalType, type }) => {
  return (
    <div className={`modal fade ${show ? "show d-block" : ""}`} tabIndex="-1" role="dialog" style={{ backgroundColor: show ? "rgba(0,0,0,0.5)" : "transparent" }}>
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title fw-bold">{title}</h5>
            <button
              type="button"
              className="btn-close"
              onClick={handleClose}
              disabled={loading}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">{children}</div>
          <div className="modal-footer border-top">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleClose}
              disabled={loading}
            >
              Cancel
            </button>

            {modalType === "create" && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => onConfirm(type)}
                disabled={loading}
              >
                {loading ? "Saving..." : "Save"}
              </button>
            )}

            {modalType === "delete" && (
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => onConfirm(type)}
                disabled={loading}
              >
                {loading ? "Deleting..." : "Delete"}
              </button>
            )}

            {modalType === "edit" && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => onConfirm(type)}
                disabled={loading}
              >
                {loading ? "Updating..." : "Update"}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BootstrapModal;